"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ArrowDownIcon = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.width, width = _c === void 0 ? '36' : _c, _d = _a.height, height = _d === void 0 ? '36' : _d, _e = _a.color, color = _e === void 0 ? '#384A51' : _e;
    return (react_1.default.createElement("svg", { className: className, width: width, height: height, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M17.1516 7.55078L12 12.7024L6.84841 7.55078L5.15161 9.24758L12 16.096L18.8484 9.24758L17.1516 7.55078Z", fill: color })));
};
exports.default = ArrowDownIcon;
